import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import fs from 'fs';
import mkdirp from 'mkdirp';

//utils
import queries from '../../utils/queries' 

import HomeLab1 from './homelab1';
import HomeLab2 from './homelab2';

import LabPrueba1 from './lab/labprueba1';
import LabPrueba2 from './lab/labprueba2';
import AddPrueba1 from './lab/addprueba1';
import AddPrueba2 from './lab/addprueba2';
import VerPrueba1 from './lab/verprueba1';
import VerPrueba2 from './lab/verprueba2';

import LabInflab1 from './lab/labinflab1';
import LabInflab2 from './lab/labinflab2';
import LabCargares1 from './lab/labcargares1';
import LabCargares2 from './lab/labcargares2';
import LabGenrte1 from './lab/labgenrte1';
import LabGenrte2 from './lab/labgenrte2';
import VerGenrte1 from './lab/vergenrte1';
import VerGenrte2 from './lab/vergenrte2';
import LabBuscInf1 from './lab/labbuscinf1';
import LabBuscInf2 from './lab/labbuscinf2';
import LabInfGer1 from './lab/labinfger1';
import LabInfGer2 from './lab/labinfger2';
import AsocDocInf1 from './lab/asocdocinf1';
import AsocDocInf2 from './lab/asocdocinf2';
import LabResLab1 from './lab/labreslab1';
import LabResLab2 from './lab/labreslab2';
import VerResLab1 from './lab/verreslab1';
import VerResLab2 from './lab/verreslab2';

import LabPruebaLab1 from './lab/labpruebaslab1';
import LabPruebaLab2 from './lab/labpruebaslab2';
import AddPruebaLab1 from './lab/addpruebaslab1';
import AddPruebaLab2 from './lab/addpruebaslab2';
import VerPruebaLab1 from './lab/verpruebaslab1';
import VerPruebaLab2 from './lab/verpruebaslab2';
import LabValRefMec1 from './lab/labvalrefmec1';
import LabValRefMec2 from './lab/labvalrefmec2';
import VerValRefMec1 from './lab/vervalrefmec1';
import VerValRefMec2 from './lab/vervalrefmec2';
import LabDashboard1 from './lab/labdashboard1';
import LabDashboard2 from './lab/labdashboard2';
import LabEnvRecMue1 from './lab/labenvrecmue1';
import LabEnvRecMue2 from './lab/labenvrecmue2';
import LabTableroLab1 from './lab/labtablerolab1';
import LabTableroLab2 from './lab/labtablerolab2';
import LabAsImInf1 from './lab/labasiminf1';
import LabAsImInf2 from './lab/labasiminf2';

var moment = require('moment');

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

class HomeLab extends React.Component{
  state={ 
    showLab: true, 
    showPrueba: false, addPrueba: false, verPrueba: false,
    showPruebaLab: false, addPruebaLab: false, verPruebaLab: false, showInfGer: false, usuario: "", showImgInf: false,
    showInflab: false, showBusclab: false, showCargares: false, showGenrte: false, verGenrte: false, showAsDocInf: false,
    showResLab: false, verResLab: false, showTableroLab: false, showTendencias: false, showDashboard: false, pruebaLAdd: [], 
    opcion: "", opcion2: "", matchEmpresa: "", numeroInflab: 0,
    showEnvRecMue: false, permiteUpdate: false, permiteDelete: false,
    permiteClose: false, argsAdd: {}, errorAdd: [], argsBuscar: {}, argsBuscEstruct: {}, argsBuscInf: {},
    idLista: {}, idListaVR: {}, argsBuscPruebaLab: {}
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

    crudBD = async (operacionCRUD, args, i)=>{
      if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
          variables: args
        });

//Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
      
    updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
  //ENVIO PARA ACTUALIZAR BD
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await this.crudBD(crudColecc[i], argsCrud[i], i)
      }
    }

    handleChangeBuscEstruct = (ev)=>{
      const argsBuscar = this.state.argsBuscar
      argsBuscar[ev.target.name] = ev.target.value
      this.setState({argsBuscar})
      this.handleBuscEstruct(argsBuscar)
    }

    handleBuscEstruct = async (args) => {
      let argsBuscar={}

      if(args.numDocum){
        argsBuscar.numDocum=args.numDocum
      }else{
        delete argsBuscar.numDocum
      }  
      if(args.descrEmpresa){
        argsBuscar.descrEmpresa=args.descrEmpresa
      }else{
        delete argsBuscar.descrEmpresa
      }
      if(args.descrPlanta){
        argsBuscar.descrPlanta=args.descrPlanta
      }else{
        delete argsBuscar.descrPlanta
      }
      if(args.descrSeccion){
        argsBuscar.descrSeccion=args.descrSeccion
      }else{
        delete argsBuscar.descrSeccion
      }
      if(args.descrEquipo){
        argsBuscar.descrEquipo=args.descrEquipo
      }else{
        delete argsBuscar.descrEquipo
      }
      if(args.descrComponente){
        argsBuscar.descrComponente=args.descrComponente
      }else{
        delete argsBuscar.descrComponente
      }
      if(args.descrMecanismo){
        argsBuscar.descrMecanismo=args.descrMecanismo
      }else{
        delete argsBuscar.descrMecanismo
      }
      this.setState({argsBuscEstruct: argsBuscar});
    }

    handleChangeBuscInf = (ev)=>{
      console.log(ev.target.name, ev.target.value)
      const argsBuscar = this.state.argsBuscar
      argsBuscar[ev.target.name] = ev.target.value
      this.setState({argsBuscar})
      this.handleBuscInf(argsBuscar)
    }
    handleBuscInf = async (args) => {
      let argsBuscar={}
      
      if(args.numDocum){
        argsBuscar.numDocum=args.numDocum
      }else{
        delete argsBuscar.numDocum
      }        
      if(args.descrEmpresa){
        argsBuscar.descrEmpresa=args.descrEmpresa
      }else{
        delete argsBuscar.descrEmpresa
      }      
      if(args.descrPlanta){
        argsBuscar.descrPlanta=args.descrPlanta
      }else{
        delete argsBuscar.descrPlanta
      }
      if(args.descrSeccion){
        argsBuscar.descrSeccion=args.descrSeccion
      }else{
        delete argsBuscar.descrSeccion
      }
      if(args.descrEquipo){
        argsBuscar.descrEquipo=args.descrEquipo
      }else{
        delete argsBuscar.descrEquipo
      }
      if(args.descrComponente){
        argsBuscar.descrComponente=args.descrComponente
      }else{
        delete argsBuscar.descrComponente
      }
      if(args.descrMecanismo){
        argsBuscar.descrMecanismo=args.descrMecanismo
      }else{
        delete argsBuscar.descrMecanismo
      }
      if(args.prioridad){
        argsBuscar.prioridad=args.prioridad
      }else{
        delete argsBuscar.prioridad
      }

      this.setState({argsBuscInf: argsBuscar});
    }

    handleBuscPruebaLab = async (ev, args) => {
      let argsBuscar={}
  
      if(args.descrPrueba){
        argsBuscar.descrPrueba=args.descrPrueba
      }else{
        delete argsBuscar.descrPrueba
      }
      if(args.descrAplicacion){
        argsBuscar.descrAplicacion=args.descrAplicacion
      }else{
        delete argsBuscar.descrAplicacion
      }
      this.setState({argsBuscPruebaLab: argsBuscar});
    }
  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showLab = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showLab: true})
  }

  showPrueba = (ev) => {
    ev.preventDefault()
    // this.props.allPrueba.refetch()
    this.estadosFalse()
    this.setState({showPrueba: true})
  }
  
  showImgInf = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showImgInf: true})
  }

  addPrueba = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPrueba: true})
  }

  showInflab = (ev) => {
    ev.preventDefault()
    // this.props.allPlantaRtes.refetch()
    this.estadosFalse()
    this.setState({showInflab: true})
  }

  showBusclab = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showBusclab: true})
  }

  showInfGer = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showInfGer: true})
  }

  showCargares = (ev) => {
    ev.preventDefault()
    // this.props.allPlantaRtes.refetch()
    this.estadosFalse()
    this.setState({showCargares: true})
  }

  showGenrte = (ev, opcion, numeroInflab) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showGenrte: true, opcion, numeroInflab})
  }

  showPruebaLab = (ev) => {
    ev.preventDefault()
    // this.props.allPrueba.refetch()
    this.estadosFalse()
    this.setState({showPruebaLab: true})
  }  

  showValRefMec = (ev) => {
    ev.preventDefault()
    // this.props.allPrueba.refetch()
    this.estadosFalse()
    this.setState({showValRefMec: true})
  }  

  showAsDocInf = (ev) => {
    ev.preventDefault()
    // this.props.allPrueba.refetch()
    this.estadosFalse()
    this.setState({showAsDocInf: true})
  }  

  showTendencias = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTendencias: true})
  }

  addPruebaLab = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPruebaLab: true})
  }

  showResLab = (ev, opcion, matchEmpresa) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showResLab: true, opcion, matchEmpresa})
  }
  showDashboard = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showDashboard: true, opcion})
  }
  showEnvRecMue = (ev, opcion, opcion2) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showEnvRecMue: true, opcion, opcion2})
  }
  showTableroLab = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTableroLab: true})
  }

  handlePrueba = async (ev, args)=>{
    if((!args.tipoPrueba||!args.descrPrueba) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoPrueba||args.tipoPrueba==="Seleccionar..."){
        argsAdd['tipoPrueba'] = "Seleccionar...";
        errors.push({path: 'tipoPrueba', message: "Debe seleccionar el tipo de prueba"});
      }
      if(!args.descrPrueba){
        argsAdd['descrPrueba'] = "";
        errors.push({path: 'descrPrueba', message: "Debe escribir la descripción"});
      }
      if(!args.validacion||args.validacion==="Seleccionar..."){
        argsAdd['validacion'] = "Seleccionar...";
        errors.push({path: 'validacion', message: "Debe seleccionar el tipo de validación"});
      }      
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPrueba){
        args.tipoProblema = 'Aceites'
        args.metodo = ''
        args.descripcion = ''
        console.log(args)
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createPrueba({
          variables: args
        });
        const {errors, success} = response.data.createPrueba;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var tipoPrueba = document.getElementById("miLista");
          var descrPrueba = document.getElementById("descrPrueba");
          var unidad = document.getElementById("unidad");
          var validacion = document.getElementById("miLista1");
          var codNorma = document.getElementById("codNorma");
          var descrNorma = document.getElementById("descrNorma");
          var campoBD = document.getElementById("campoBD");
          var analisisCon = document.getElementById("analisisCon");
          var analisisPre = document.getElementById("analisisPre");
          var analisisAla = document.getElementById("analisisAla");
          var analisisPel = document.getElementById("analisisPel");
          var recomenCon = document.getElementById("recomenCon");
          var recomenPre = document.getElementById("recomenPre");
          var recomenAla = document.getElementById("recomenAla");
          var recomenPel = document.getElementById("recomenPel");
          var descrArchivo = document.getElementById("descrArchivo");
          // var tipoProblema = document.getElementById("miLista2");
          tipoPrueba.options.selectedIndex = 0   
          validacion.options.selectedIndex = 0   
          // tipoProblema.options.selectedIndex = 0
          descrPrueba.value = ""
          codNorma.value = ""
          descrNorma.value = ""
          unidad.value = ""
          campoBD.value = ""
          analisisCon = ""
          analisisPre = ""
          analisisAla = ""
          analisisPel = ""
          recomenCon = ""
          recomenPre = ""
          recomenAla = ""
          recomenPel = ""
          descrArchivo.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPrueba.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          console.log(args)
          const argsUpd = {
            _id: args._id,
            tipoPrueba: args.tipoPrueba,
            descrPrueba: args.descrPrueba,
            validacion: args.validacion,
            codNorma: args.codNorma,
            descrNorma: args.descrNorma,    
            unidad: args.unidad,    
            campoBD: args.campoBD,
            analisisCon: args.analisisCon?args.analisisCon:'',
            analisisPre: args.analisisPre?args.analisisPre:'',
            analisisAla: args.analisisAla?args.analisisAla:'',
            analisisPel: args.analisisPel?args.analisisPel:'',
            recomenCon: args.recomenCon?args.recomenCon:'',
            recomenPre: args.recomenPre?args.recomenPre:'',
            recomenAla: args.recomenAla?args.recomenAla:'',
            recomenPel: args.recomenPel?args.recomenPel:'',
            descrArchivo: args.descrArchivo,  
            tipoProblema: args.tipoProblema,                      
            tipoAct: 'EditarPr'
          }
          const response = await this.props.editPrueba({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPrueba;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPrueba.refetch()
            this.estadosFalse()
            this.setState({showPrueba: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deletePrueba({
            variables: argsDel
          });
          this.props.allPrueba.refetch()
          this.estadosFalse()
          this.setState({showPrueba: true})
        }
      }
    }
  }

  handlePruebaLab = async (ev, args, descrAplicacionAnt)=>{
    let idPruebaSel = args._id
    const errors = [];
    if((!args.descrPrueba||args.descrAplicacion==="Seleccionar...") && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      if(!args.descrPrueba||args.descrPrueba==="Seleccionar..."){
        argsAdd['descrPrueba'] = "Seleccionar...";
        errors.push({path: 'descrPrueba', message: "Debe seleccionar la prueba"});
      }
      if(!args.descrAplicacion||args.descrAplicacion==="Seleccionar..."){
        argsAdd['descrAplicacion'] = "Seleccionar...";
        errors.push({path: 'descrAplicacion', message: "Debe seleccionar la aplicación"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPruebaLab){
        if(errors.length!==0){
          this.setState({errorAdd: errors})
        }else{
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          const argsUpd = {
            "descrPrueba": args.descrPrueba,
            "tipoAct": "CrearVR",
            "descrAplicacion": args.descrAplicacion,
            "valor1Alarma": args.valor1Alarma,
            "valor2Alarma": args.valor2Alarma,
            "valor3Alarma": args.valor3Alarma,
            "valor1Corte": args.valor1Corte,
            "valor2Corte": args.valor2Corte,
            "valor3Corte": args.valor3Corte,
            "fechaCreate": fechaHoraHoy,
          }
          response = await this.props.editPrueba({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPrueba;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            let pruebaLAdd = this.state.pruebaLAdd
            pruebaLAdd.push({_id: this.state.pruebaLAdd, descrAplicacion: argsUpd.descrAplicacion, 
              valor1Alarma: argsUpd.valor1Alarma, valor2Alarma: argsUpd.valor2Alarma, 
              valor3Alarma: argsUpd.valor3Alarma, valor1Corte: argsUpd.valor1Corte, valor2Corte: argsUpd.valor2Corte, 
              valor3Corte: argsUpd.valor3Corte})
      
            var descrAplicacion = document.getElementById("miLista1");
            descrAplicacion.options.selectedIndex = 0        
            var valor1Alarma = document.getElementById("valor1Alarma");
            valor1Alarma.value = 0
            var valor1Corte = document.getElementById("valor1Corte");
            valor1Corte.value = 0        
            if (args.validacion==='Aplicación - Rango de % en Aceite nuevo'){
              var valor2Alarma = document.getElementById("valor2Alarma");
              valor2Alarma.value = 0
              var valor2Corte = document.getElementById("valor2Corte");
              valor2Corte.value = 0                    
            }
            if (args.validacion==='Aplicación - Mayor que 3 valores'){
              var valor2Alarma = document.getElementById("valor2Alarma");
              valor2Alarma.value = 0
              var valor2Corte = document.getElementById("valor2Corte");
              valor2Corte.value = 0       
              var valor3Alarma = document.getElementById("valor3Alarma");
              valor3Alarma.value = 0
              var valor3Corte = document.getElementById("valor3Corte");
              valor3Corte.value = 0                   
            }
            this.setState({errorAdd: []})
            this.setState({argsAdd: {}})
            this.setState({pruebaLAdd})
          }
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            "descrPrueba": args.descrPrueba,
            "tipoAct": "EditarVR",
            "descrAplicacion": args.descrAplicacion,
            "valor1Alarma": args.valor1Alarma,
            "valor2Alarma": args.valor2Alarma,
            "valor3Alarma": args.valor3Alarma,
            "valor1Corte": args.valor1Corte,
            "valor2Corte": args.valor2Corte,
            "valor3Corte": args.valor3Corte, 
          }
          // console.log(argsUpd)
          const response = await this.props.editPrueba({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPrueba;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            let pruebaLAdd = this.state.pruebaLAdd
            pruebaLAdd.forEach((elemento, i) => {
              // if(elemento.numCuenta===argsUpd.numCuentaAnt){
                pruebaLAdd[i].descrAplicacion = argsUpd.descrAplicacion
                pruebaLAdd[i].valor1Alarma = argsUpd.valor1Alarma
                pruebaLAdd[i].valor2Alarma = argsUpd.valor2Alarma
                pruebaLAdd[i].valor3Alarma = argsUpd.valor3Alarma
                pruebaLAdd[i].valor1Corte = argsUpd.valor1Corte
                pruebaLAdd[i].valor2Corte = argsUpd.valor2Corte
                pruebaLAdd[i].valor3Corte = argsUpd.valor3Corte
              // }
            })
            this.estadosFalse()
            this.setState({showPruebaLab: true})
            this.setState({pruebaLAdd})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "descrPrueba": args.descrPrueba,
            "tipoAct": "EliminarVR",
            "descrAplicacion": args.descrAplicacion,
          }
          const response = await this.props.editPrueba({
            variables: argsDel
          });
          const {errors, success} = response.data.editPrueba;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            let pruebaLAdd = this.state.pruebaLAdd
            const indexVR = pruebaLAdd.findIndex( prueba => prueba.descrAplicacion === args.descrAplicacion );
            pruebaLAdd.splice(indexVR, 1);
  
            this.estadosFalse()
            this.setState({showPruebaLab: true})
            this.setState({pruebaLAdd})
          }
        }
      }
    }
  }

  handleValRefMec = async (ev, args)=>{
    let idPruebaSel = args._id
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = await response.data.fecha
    // const errors = [];
    // if(this.state.permiteUpdate){
      const argsUpd = {
        "descrEmpresa": args.descrEmpresa,
        "descrPlanta": args.descrPlanta,
        "descrSeccion": args.descrSeccion,
        "descrEquipo": args.descrEquipo,
        "descrComponente": args.descrComponente,
        "descrMecanismo": args.descrMecanismo,
        "descrAplicacion": args.descrAplicacion,
        "descrPrueba": args.descrPrueba,
        "tipoAct": "EditarVR",
        "valor1Alarma": args.valor1Alarma,
        "valor2Alarma": args.valor2Alarma,
        "valor3Alarma": args.valor3Alarma,
        "valor1Corte": args.valor1Corte,
        "valor2Corte": args.valor2Corte,
        "valor3Corte": args.valor3Corte,
      }
      response = await this.props.editMecValRef({
        variables: argsUpd
      });
      const {errors, success} = response.data.editMecValRef;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.estadosFalse()
        this.setState({showValRefMec: true})
      }
    // }
  }


  handleUpdAsDocInf = async (ev, idListaP)=>{
    console.log(ev.target) 

    // console.log(ev.target.files)
    // console.log(idListaP)
    let listImg = ev.target.files

    if(listImg.length===1){
      if(idListaP.mecInflab){
        let numImgAsoc = 0

        let validImg = []
        // validImg.forEach(async (elemento, i) => {
        for(let ii=0; ii<listImg.length; ii++){
          console.log(listImg[ii].name)

                  
  // //quitar espacios en blanco al nombre del archivo
  // let nombreArch = listImg[ii].name.replace(/^\s+|\s+/g, '')
  // console.log(nombreArch)

          //VALIDAR SI EL ARCHIVO EXISTE (ESTA EN LA CARPETA => NO SE COPIA)
          let argsBuscar = {}
          argsBuscar = `'mecInflab': '${idListaP.mecInflab}', 'nomArchivo': '${listImg[ii].name}'`

          let argsBuscarI = {}
          argsBuscarI = {tipoqry: `[{$match: {${argsBuscar}}}]`}
          let regExisteArch = [], regExiste = 0

          validImg.push({name: listImg[ii].name, existe: regExiste, existeArch: regExisteArch.length})
          if(regExiste===0){
            numImgAsoc += 1
          }
          console.log(regExiste, regExisteArch)
        }
  console.log(validImg)

        if(numImgAsoc>0){
          document.body.style.cursor = 'wait'
        }

        // console.log(this.state.idListaP.descrEquipo)
        let file = ""
        //Se define el ancho y alto de la imagen (entre mas grande mejor resolucion)
        // let ancho = 800
        // let alto = 532
        for(let ii=0; ii<listImg.length; ii++){
          if(validImg[ii].existe===0){ 
            // console.log(listImg[ii].name, validImg[ii].name, validImg[ii].existe)
            file = listImg[ii]
            // console.log(URL.createObjectURL(file))
 
            //COPIA EL ARCHIVO EN LA CARPETA DEL SERVIDOR './slcm-client/public/images/cartas'
            let archCopiado = ""
            if(validImg[ii].existeArch===0){
              console.log("Existe archivo")
              let response = await this.props.singleUpload({variables: {file}});
              archCopiado = response.data.singleUpload.filename
              console.log("Copiado")
            }{
              // console.log("NO se copia")
            }

            //PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS

            let movColecc = []
            let argsUpd = {
              "tipoAct": 'EditarArch',
              "nomArchivo": listImg[ii].name,
              "mecInflab": idListaP.mecInflab
            }
            movColecc.push(argsUpd)

            let numDocCRUD = 0
            let totDocCRUD = 1
            let argsCrud = []
            let crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editInflab)
            }

            argsCrud[numDocCRUD] = movColecc[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editInflab

            await this.updColecc(crudColecc, argsCrud, totDocCRUD)

            argsUpd = {}
            movColecc = []
            argsUpd = {
              "tipoAct": 'EditarArchInflab',
              "nomArchivo": listImg[ii].name,
              "mecInflab": idListaP.mecInflab
            }
            movColecc.push(argsUpd)

            numDocCRUD = 0
            totDocCRUD = 1
            argsCrud = []
            crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editOrden)
            }

            argsCrud[numDocCRUD] = movColecc[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editOrden

            await this.updColecc(crudColecc, argsCrud, totDocCRUD)


                  //FIN IMAGEN NUEVA

            if(ii===listImg.length-1){
              document.body.style.cursor = 'default'
              alert("!! Documento cargado !!")

              const argsBuscInf = this.state.argsBuscInf
              this.setState({argsBuscInf});
              this.handleBuscInf(argsBuscInf)

              document.getElementById("img").value = ""
            }
          }
        }
      }else{
        alert("!! Por favor seleccione el reporte !!")
        // document.getElementById("img").value = ""
      }
    }else{
      alert("!! Solo le puede asociar un archivo a cada reporte !!")
    }
  }

  handleElimAsDocInf = async (ev, idListaP)=>{
    // console.log("Eliminar", idListaP)
    
        if(idListaP.nomArchivo){
          //VALIDAR SI EL ARCHIVO ESTA ASOCIADO VARIAS VECES => NO SE COPIA
          let movColecc = []
          let argsUpd = {
            "tipoAct": 'EditarArch',
            "nomArchivo": '',
            // "nomArchivoAnt": idListaP.nomArchivo,
            "mecInflab": idListaP.mecInflab
          }
          console.log(argsUpd)
          movColecc.push(argsUpd)
          // console.log(movColecc)

          let numDocCRUD = 0
          let totDocCRUD = 1
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editInflab)
          }

          argsCrud[numDocCRUD] = movColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editInflab

          console.log(argsCrud)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
                //FIN IMAGEN NUEVA

          document.body.style.cursor = 'default'
          alert("!! Documento eliminado !!")

          const argsBuscInf = this.state.argsBuscInf
          this.setState({argsBuscInf});
          this.handleBuscInf(argsBuscInf)

          document.getElementById("img").value = ""
        }else{
          alert("!! Por favor seleccione el documento a eliminar !!")
        }
      }
    

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd

    let datoTipo = ""
    if(input!==undefined&&ev.target.name===undefined){
      datoTipo = input.type
    } 

    if(datoTipo==='checkbox'){
      if (this.state.addEstructura) {
        argsAdd[input.name] = input.label
      }else{
        argsAdd[input.name] = input.checked
      }
    }else{
      if(ev.target.type==='checkbox'){
        argsAdd[ev.target.name] = ev.target.checked
      }else{
        argsAdd[ev.target.name] = ev.target.value
      }
    }
    this.setState({argsAdd});
  }

  handleSeltipoPrueba = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoPrueba'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelvalidacion = () => {
    var miLista1 = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['validacion'] = miLista1.options[miLista1.selectedIndex].text
    this.setState({argsAdd});
  }
  handleSeltipoProblema = () => {
    var miLista2 = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoProblema'] = miLista2.options[miLista2.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSeldescrPrueba = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd 
    argsAdd['descrPrueba'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['validacion'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['_id'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['validacion'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }  

  handleSeldescrAplicacion = () => {
    var miLista1 = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrAplicacion'] = miLista1.options[miLista1.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSelPlanta = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrPlanta'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codPlanta'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelSeccion = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrSeccion'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codSeccion'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelEquipo = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEquipo'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codEquipo'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['nombreUsuario'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['acumulado'] = miLista.options[miLista.selectedIndex].attributes[3].value
    this.setState({argsAdd});
  } 
  handleSelComponente = () => {
    var miLista = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrComponente'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codComponente'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelMecanismo = () => {
    var miLista = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['descrMecanismo'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codMecanismo'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['codigoQR'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['claseLub'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['descrAplicacion'] = miLista.options[miLista.selectedIndex].attributes[3].value
    argsAdd['descrFabricante'] = miLista.options[miLista.selectedIndex].attributes[4].value
    argsAdd['descrLubricante'] = miLista.options[miLista.selectedIndex].attributes[5].value
    argsAdd['categoriaLub'] = miLista.options[miLista.selectedIndex].attributes[6].value
    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].attributes[7].value
    argsAdd['tipoFrecuencia'] = miLista.options[miLista.selectedIndex].attributes[8].value
    argsAdd['abrevUnidadTF'] = miLista.options[miLista.selectedIndex].attributes[9].value
    argsAdd['cantidadTotal'] = miLista.options[miLista.selectedIndex].attributes[10].value
    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].attributes[11].value
    argsAdd['abrevUnidad'] = miLista.options[miLista.selectedIndex].attributes[12].value
    this.setState({argsAdd});
  }


  handleGenrte = async (ev, args)=>{
    let idPruebaSel = args._id

    let argsUpd=args

    if(!args.apariencia || args.apariencia===null || args.apariencia==='' || args.apariencia==='Seleccionar...'){
      argsUpd.apariencia=''
    }
    if(!args.olor || args.olor===null || args.olor==='' || args.olor==='Seleccionar...'){
      argsUpd.olor=''
    }

    let fechaMuestra = moment(args.fechaMuestra).format('YYYY-MM-DD')
    argsUpd.fechaMuestra=fechaMuestra
    argsUpd.tipoAct='EditarResultados'
    console.log(argsUpd)
    const response = await this.props.editInflab({
        variables: argsUpd
    });
    const {errors, success} = response.data.editInflab;
    if (!success){
      this.setState({errorAdd: errors})
    }else{
      this.estadosFalse()
      this.setState({showGenrte: true, numeroInflab: argsUpd.numeroInflab})
    }
  }

  handleSelSiNo = (ev, nameLista) => {
    // console.log(nameLista)
    var miLista = document.getElementById(nameLista);
    const argsAdd = this.state.argsAdd
    if (nameLista==='miLista1'){
    argsAdd['cambioFiltroAc'] = miLista.options[miLista.selectedIndex].text
    }
    if (nameLista==='miLista2'){
      argsAdd['cambioFiltroAire'] = miLista.options[miLista.selectedIndex].text
    }  
    // console.log(argsAdd)
    this.setState({argsAdd});
  } 

  idLista = async (ev, idLista, numeroInflab)=>{
    console.log(idLista)
    console.log(numeroInflab)

    if (this.state.showPruebaLab) {
      this.setState({idListaAp: idLista})
    }else{
      this.setState({idLista: idLista})
    }    
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showPrueba) {
      this.setState({verPrueba: true})
    }
    if (this.state.showPruebaLab) {
      this.setState({verPruebaLab: true})
    } 
    if (this.state.showValRefMec) {
      this.setState({verValRefMec: true})
    }   
    if (this.state.showGenrte) {
      console.log(numeroInflab)

      this.setState({verGenrte: true, numeroInflab})
    }   
    if (this.state.showResLab) {
      this.setState({verResLab: true})
    } 
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false, permiteClose: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: true, permiteClose: false})
  }

  handleClickClo = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: false, permiteClose: true})
  }

handleUpdAsImLab = async (ev)=>{
  let listImg = ev.target.files
  if(listImg.length>0){
    document.body.style.cursor = 'wait'

    let imagen = ""
    for(let ii=0; ii<listImg.length; ii++){
      let file = listImg[ii]
      let response = await this.props.singleUpload({variables: {file}});
      let movColecc = []
      let argsUpd = {
        "tipoAct": 'subirImgInf',
        "nomArchivo": listImg[ii].name
      }
      movColecc.push(argsUpd)

      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editInflab)
      }

      argsCrud[numDocCRUD] = movColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editInflab

      await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      if(ii===listImg.length-1){
        document.body.style.cursor = 'default'
        alert("!! Proceso finalizado !!")
      }
    }
  }
}

  render(){
    const {showLab, showPrueba, addPrueba, verPrueba, showInflab, showCargares, showGenrte, verGenrte, showEnvRecMue, showTableroLab, 
           showPruebaLab, addPruebaLab, verPruebaLab, opcion, opcion2, usuario, numeroInflab, matchEmpresa, showBusclab, showInfGer, showAsDocInf, 
          permiteUpdate, permiteDelete, permiteClose, showValRefMec, verValRefMec, showResLab, verResLab, showTendencias, showDashboard,
          argsAdd, errorAdd, argsBuscar, argsBuscEstruct, argsBuscInf, argsBuscPruebaLab, idLista, idListaAp, showImgInf} = this.state;
// console.log(argsBuscInf)
      let lista = []
      let lista1 = []
      let lista2 = []
      let lista7 = []
      let descrEmpresaUA=localStorage.getItem('Empresa')

      if (this.state.showPrueba) {
        if(this.props.allPrueba.allPrueba){lista = this.props.allPrueba.allPrueba}
        // console.log(lista)
      }
    
      if (this.state.showAsDocInf) {
        lista1.push({descrEmpresa: "Seleccionar Empresa...", logo: "", _id: 0})
        // if(this.props.allEmpresa.allEmpresa){
        //   this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
        //     lista1.push({descrEmpresa: elemento.descrEmpresa, logo: elemento.logo, _id: ii+1})
        //   })
        // }
        if(descrEmpresaUA==="Todas..."){
          if(this.props.allEmpresa.allEmpresa){
            this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
              lista1.push({descrEmpresa: elemento.descrEmpresa, logo: elemento.logo, _id: ii+1})
            })
          }
        }else{
          lista1.push({descrEmpresa: descrEmpresaUA, logo: "", _id: 0})
        }
      }
       
      if (this.state.addPruebaLab  || this.state.verPruebaLab) {
        if(this.props.allPrueba.allPrueba){lista = this.props.allPrueba.allPrueba}
        if(this.props.allAplicacion.allAplicacion){lista1 = this.props.allAplicacion.allAplicacion}
      } 
      if (this.state.verValRefMec) {
        if(this.props.allMecValRefRtes.allMecValRefRtes){lista = this.props.allMecValRefRtes.allMecValRefRtes}
      } 
      if (this.state.showInflab) {
        // if(this.props.allEmpresa.allEmpresa){lista2 = this.props.allEmpresa.allEmpresa}
        lista2.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
        if(descrEmpresaUA==="Todas..."){
          if(this.props.allEmpresa.allEmpresa){
            this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
              lista2.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
            })
          }
        }else{
          lista2.push({descrEmpresa: descrEmpresaUA, _id: 0})
        }
      } 
      if (this.state.showTendencias) {
        lista.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
        if(descrEmpresaUA==="Todas..."){
          if(this.props.allEmpresa.allEmpresa){
            this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
              lista.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
            })
          }
        }else{
          lista.push({descrEmpresa: descrEmpresaUA, _id: 0})
        }
      }

      if(this.state.showDashboard){
        // if(this.props.allInflabRtesDash1.allInflabRtes){lista = this.props.allInflabRtesDash1.allInflabRtes}
        // console.log(lista.length)
        // if(this.props.allInflabRtesDash2.allInflabRtes){lista2 = this.props.allInflabRtesDash2.allInflabRtes}
      }
      let fechaFin = new Date()
      fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())

      //calcular fechaHoy como 364 dias antes de la fecha actual
      let fechaHoy = parseInt((new Date().getTime() - (1000*60*60*24)*364), 10)
      fechaHoy = new Date(fechaHoy)
      fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

    return ( 
      <div>
        {!showTendencias &&
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showLab && <HomeLab1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                        handleClickSel11={this.showPrueba} handleClickSel12={this.showPruebaLab}
                        handleClickSel13={this.showInflab} handleClickSel14={this.showCargares} 
                        handleClickSel15={(ev)=>this.showGenrte(ev, "GENERADO", numeroInflab)}
                        handleClickSel16={(ev)=>this.showGenrte(ev, "FINALIZADO", numeroInflab)}
                        handleClickSel21={(ev)=>this.showResLab(ev, "FINALIZADO", this.props.matchEmpresa)}
                        handleClickSel17={this.showBusclab} handleClickSel18={this.showInfGer}
                        handleClickSel19={this.showAsDocInf} handleClickSel20={this.showValRefMec}
                        handleClickSel22={this.showImgInf} handleClickSel23={this.showDashboard}
                        handleClickSel24={(ev)=>this.showEnvRecMue(ev, "Sin enviar", "GENERADO")}
                        handleClickSel25={(ev)=>this.showEnvRecMue(ev, "Enviada", "GENERADO")}
                        handleClickSel26={(ev)=>this.showEnvRecMue(ev, "Recibida", "FINALIZADO")}
                        handleClickSel27={this.showTableroLab}/>}
                        

            {showPrueba && <LabPrueba1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
            {addPrueba && <AddPrueba1 styles={this.props.styles} handleClickRegr={this.showPrueba}/>}
            {verPrueba && <VerPrueba1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showPrueba} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showInflab && <LabInflab1 styles={this.props.styles} handleClickRegr={this.showLab}
                        handleChange={this.handleChangeBuscInf} handleSubmit={this.handleBuscInf}
                        args={argsBuscar}/>}

            {showCargares && <LabCargares1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
 
            {showGenrte && <LabGenrte1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
            {showImgInf && <LabAsImInf1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
            {verGenrte && <VerGenrte1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={(ev)=>this.showGenrte(ev, opcion, numeroInflab)} handleClickUpd={this.handleClickUpd}/>}

            {showPruebaLab && <LabPruebaLab1 styles={this.props.styles} handleClickRegr={this.showLab}
                        handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscPruebaLab}
                        args={argsBuscar}/>}
            {addPruebaLab && <AddPruebaLab1 styles={this.props.styles} handleClickRegr={this.showPruebaLab}/>}
            {verPruebaLab && <VerPruebaLab1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showPruebaLab} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>} 
            {showValRefMec && <LabValRefMec1 styles={this.props.styles} handleClickRegr={this.showLab}
                        handleChange={this.handleChangeBuscEstruct} 
                        handleSubmit={this.handleBuscEstruct}
                        args={argsBuscar}/>}
            {verValRefMec && <VerValRefMec1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showValRefMec} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}            
          
            {showAsDocInf && <AsocDocInf1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscInf} handleSubmit={this.handleBuscInf}
                args={argsBuscInf} handleClickRegr={this.showLab}/>}

            {showBusclab && <LabBuscInf1 styles={this.props.styles} handleClickRegr={this.showLab}
                        handleChange={this.handleChangeBuscInf} handleSubmit={this.handleBuscInf}
                        args={argsBuscar}/>}  
            {showInfGer && <LabInfGer1 styles={this.props.styles}
                handleChange={this.handleChangeBuscInf} handleSubmit={this.handleBuscInf}
                args={argsBuscar} handleClickRegr={this.showLab}/>}          
          
            {showResLab && <LabResLab1 styles={this.props.styles} handleClickRegr={this.showLab}
                handleChange={this.handleChangeBuscInf} handleSubmit={this.handleBuscInf}
                args={argsBuscar}/>}
            {verResLab && <VerResLab1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={(ev)=>this.showResLab(ev, opcion, matchEmpresa)} 
                idLista={idLista}/>}
            {showEnvRecMue && <LabEnvRecMue1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
            {showDashboard && <LabDashboard1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
            {showTableroLab && <LabTableroLab1 styles={this.props.styles} handleClickRegr={this.showLab}/>}
          </div> 

          <div className="column" style={this.props.styles.boxDer}>
            {showLab && <HomeLab2 styles={this.props.styles}/>}
 
            {showPrueba && <LabPrueba2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addPrueba} list={lista} handleClickidLista={this.idLista}/>}
            {addPrueba && <AddPrueba2 styles={this.props.styles} handleLista={this.handleSeltipoPrueba} 
                handleLista1={this.handleSelvalidacion} 
                handleSubmit={this.handlePrueba} handleChange={this.handleChange} 
                args={argsAdd} errors={errorAdd} />}
            {verPrueba && <VerPrueba2 styles={this.props.styles} handleSubmit={this.handlePrueba} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showInflab && <LabInflab2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscInf={argsBuscInf} list2={lista2} usuario={this.props.usuario}/>}

            {showBusclab && <LabBuscInf2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                argsBuscInf={argsBuscInf}/>}
            
            {showCargares && <LabCargares2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
            {showImgInf && <LabAsImInf2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleUpdAsImLab={this.handleUpdAsImLab}/>}

            {showGenrte && <LabGenrte2 autorizacUA={this.props.autorizacUA} versionMacroUA={this.props.versionMacroUA} 
                styles={this.props.styles} numeroInflab={numeroInflab}
                rutaLogo={this.props.rutaLogo} handleClickidLista={this.idLista} opcion={opcion}/>}
            {verGenrte && <VerGenrte2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleSubmit={this.handleGenrte} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={true} 
                permiteDelete={permiteDelete} opcion={opcion}/>} 
            {showInfGer && <LabInfGer2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} versionMacroUA={this.props.versionMacroUA} 
                rutaLogo={this.props.rutaLogo} argsBuscInf={argsBuscInf} fechaFin={fechaFin} fechaHoy={fechaHoy}/>}

            {showResLab && <LabResLab2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleClickidLista={this.idLista} opcion={opcion} matchEmpresa={matchEmpresa}
                argsBuscInf={argsBuscInf}/>}
            {verResLab && <VerResLab2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}  
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={true} 
                permiteDelete={permiteDelete} opcion={opcion}/>} 

            {showAsDocInf && <AsocDocInf2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  // list={lista} 
                  list1={lista1} handleUpdAsDocInf={this.handleUpdAsDocInf}
                  handleElimAsDocInf={this.handleElimAsDocInf} argsBuscInf={argsBuscInf}
                  handleChange={this.handleChangeBuscInf}/>} 
            {showPruebaLab && <LabPruebaLab2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addPruebaLab} handleClickidLista={this.idLista} argsBuscPruebaLab={argsBuscPruebaLab}
                pruSel={idLista.descrPrueba}/>}
            {addPruebaLab && <AddPruebaLab2 styles={this.props.styles} list={lista} list1={lista1}
                handleLista={this.handleSeldescrPrueba} handleLista1={this.handleSeldescrAplicacion}
                pruSel={idLista.descrPrueba} idLista={idLista}
                handleSubmit={this.handlePruebaLab} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verPruebaLab && <VerPruebaLab2 styles={this.props.styles} list={lista} list1={lista1} handleSubmit={this.handlePruebaLab} 
                args={argsAdd} errors={errorAdd} idListaPr={idLista} idLista={idListaAp} pruSel={idLista.descrPrueba}
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}   

            {showValRefMec && <LabValRefMec2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
               handleClickidLista={this.idLista} argsBuscEstruct={argsBuscEstruct}/>}                
            {verValRefMec && <VerValRefMec2 styles={this.props.styles} list={lista} handleSubmit={this.handleValRefMec} 
                args={argsAdd} errors={errorAdd} idLista={idLista} 
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>} 
            {showEnvRecMue && <LabEnvRecMue2 autorizacUA={this.props.autorizacUA}  
                styles={this.props.styles} opcion={opcion} opcion2={opcion2}/>}    
            {showDashboard && <LabDashboard2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}           
            {/* {showTendencias && <LabTendencias2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleLista={this.handleSelPlanta} handleLista1={this.handleSelSeccion}
                handleLista2={this.handleSelEquipo} handleLista3={this.handleSelComponente}
                handleLista4={this.handleSelMecanismo} handleLista5={this.handleSelHallazgo}
                handleLista6={this.handleSelTarea} handleLista7={this.handleSelModo} handleLista8={this.handleSelUsuario}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} list={lista} 
                fechaFin={fechaFin} fechaHoy={fechaHoy}/>} */}
            {showTableroLab && <LabTableroLab2 styles={this.props.styles}/>}
          </div> 
        </div>
}
        </div>
    )
  }
}

export default compose( 
  graphql(queries.query.allPrueba, {name:'allPrueba', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allPruebaRtes, {name:'allPruebaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoPrueba': {$ne: 'Pruebas especiales'}}}]`}}}}),
  graphql(queries.mutation.createPrueba, {name:'createPrueba'}),
  graphql(queries.mutation.editPrueba, {name:'editPrueba'}),
  graphql(queries.mutation.deletePrueba, {name:'deletePrueba'}),
  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.query.allMecValRefRtes, {name:'allMecValRefRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),
  graphql(queries.mutation.editMecValRef, {name:'editMecValRef'}),
  graphql(queries.mutation.editInflab, {name:'editInflab'}),
  graphql(queries.mutation.editInflab, {name:'editOrden'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  

)(HomeLab) 
